import { inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ApiService, CacheHelperService, SecurityService } from "@tylertech/core-module";
import { KeyValue } from "@tylertech/tyler-api-types";
import { CodeLookupService } from "./codeLookupService.g";
import { ConcurrentCallLimit } from "../utilities/ConcurrentCallLimit";

@Injectable()
export class CachedCodeLookupService
    extends CodeLookupService
{

    concurrentCallLimit : ConcurrentCallLimit<KeyValue[]> = new ConcurrentCallLimit<KeyValue[]>(10);

    constructor(
        private readonly $cacheHelperService: CacheHelperService,
    )
    {
        super(inject(ApiService));

        const securityService = inject(SecurityService);
        securityService.principleChange
            .pipe(takeUntilDestroyed())
            .subscribe(() =>
            {
                if (securityService.isAuthenticated)
                {
                    return;
                }

                this.$cacheHelperService.clearAll();
            });
    }

    override Get(type: string, filterString?: string): Promise<KeyValue[]>
    {
        let self = this;
        return this.$cacheHelperService.routeThroughCache(
            `${CachedCodeLookupService.name}.Fetch`,
            {
                Item1: type,
                Item2: filterString,
            },
            x => {
                return self.concurrentCallLimit.run(() => super.Get(x.Item1, x.Item2));
            }
        );
    }

    clearCache(type: string, filterString?: string): void
    {
        this.$cacheHelperService.clear(type, filterString);
    }
}
